<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" :ref="ref" @ok="ok"
           :modal-class="modalClass"
  >
    <frontoffice-loader v-if="isLoading && !displayError"/>

    <div v-else>
      {{ $t('booking.confirm.question1') }}
      <br/>
      {{ $t('booking.confirm.question2') }}
    </div>

    <b-alert v-if="displayError" variant="danger" show class="col-12">
      {{ errorMessage }}
    </b-alert>
  </b-modal>
</template>

<script>
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import frontofficeLoader from '@/components/frontoffice/loader'
import loadingModalMixin from'@/components/frontoffice/mixins/loadingModal'

export default {
  name: 'booking-modal-confirm',

  components: {
    frontofficeLoader
  },

  mixins: [modalMixin, loadingModalMixin],

  props: {
    id: {
      type: String,
      default: "confirm"
    },
    isOnline: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      ref: null,
      displayError: false,
      errorMessage: '',
      closeAfterServerResponse: false
    }
  },

  created () {
    this.ref = this.isOnline ? 'online_validate' : 'confirm'
    this.closeAfterServerResponse = true
  },

  methods: {
    ok (event) {
      if (!this.displayError) {
        event.preventDefault()
        this.isLoading = this.isOnline
        this.displayError = false
        this.confirm()
      }
    },

    setErrorMessage (msg) {
      this.displayError = true
      this.isLoading = false
      this.errorMessage = msg
    },

    reset () {
      this.isLoading = false
      this.displayError = false
    }
  },

  computed: {
    submitterInfos () {
      return {
        type: this.isOnline ? 'online_validate' : 'booking_confirm',
        values: this.isOnline ? { bookingId: this.bookingId } : null
      }
    },

    successMessage () {
      let cieStore = this.$store.getters['security/company']

      if (cieStore.orderNumber && cieStore.orderNumber.required) {
        let label = cieStore.orderNumber.label || this.$t('_orderNumber')
        let transKey = 'booking.requestConfirm.'

        return `${this.$t(transKey + 'confirm')} ${this.$t(transKey + 'orderNumber.main', { label: label })}`
      }

      return this.$t('booking.confirm.validation')
    }
  }
}
</script>
